import React, { useState, useEffect } from 'react';

import { googleLogout, useGoogleLogin } from '@react-oauth/google';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import { googlelogin } from '../../ActionCreators/loginAction';

export default function GLogin() {
    const [user, setUser] = useState(null);
    const [profile, setProfile] = useState(null);
    const dispatch = useDispatch();
    const login = useGoogleLogin({
        auto_select: true,
        onSuccess: (codeResponse) => {
            console.log(codeResponse)
            setUser(codeResponse)
        },
        onError: (error) => console.log('Login Failed:', error)
    });

    useEffect(
        () => {
            if (user) {
                axios
                    .get(`https://www.googleapis.com/oauth2/v1/userinfo?access_token=${user.access_token}`, {
                        headers: {
                            Authorization: `Bearer ${user.access_token}`,
                            Accept: 'application/json'
                        }
                    })
                    .then((res) => {
                        setProfile(res.data);
                        dispatch(googlelogin(res.data))
                    })
                    .catch((err) => console.log(err));
            }
        },
        [user !== null]
    );

    // log out function to log the user out of google and set the profile array to null
    const logOut = () => {
        googleLogout();
        setProfile(null);
    };

    return (
        <div>

            <button className='form-control' style={{ borderRadius: 2, height: 48, color: '#000000', fontWeight: 'bold' }} onClick={() => login()}><img src='/images/g1.png' alt='' style={{ verticalAlign: 'middle' }} width={20} />&nbsp;&nbsp; Sign in with Google</button>
        </div>
    );
}
